// extracted by mini-css-extract-plugin
export default {"personal_banking_btn":"Button_personal_banking_btn__uR+lf"};